import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifService } from 'src/app/core/notification/notif.service';
import { Constants } from 'src/app/constants';
import { EventNotificationService } from 'src/app/data-access-layer/notification/event-notification.service';

@Component({
  selector: 'map-unsubscribe-alert',
  templateUrl: './unsubscribe-alert.component.html',
  styleUrls: ['./unsubscribe-alert.component.scss']
})
export class UnsubscribeAlertComponent {
  readonly unsubscribeAlertForm: UntypedFormGroup;
  isTokenValid: boolean = true;
  isAlreadyUnsubscribed: boolean = false;

  constructor(
      private readonly formBuilder: UntypedFormBuilder,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private notifService: NotifService,
    private readonly eventNotifService: EventNotificationService) {
      this.unsubscribeAlertForm = this.formBuilder.group({
          reason: [''],
        }
      );
    }

  ngOnInit(): void {
          let token = this.activatedRoute.snapshot.paramMap.get('token');
          this.eventNotifService.checkNotificationStatus(token).subscribe(
              success => {
                  this.isTokenValid = success;
                  this.isAlreadyUnsubscribed = !success;
              }, error => {
                  if (error.status === Constants.AUTH_ERROR_CODE) {
                      this.isTokenValid = true;
                      this.isAlreadyUnsubscribed = false;
                  }
              }
          );
    }

    onSubmit(): void {
      let token = this.activatedRoute.snapshot.paramMap.get('token');
      let form = this.unsubscribeAlertForm.value;
      if (token && this.unsubscribeAlertForm.valid) {
          this.eventNotifService.unsubscribeNotification(token, form)
              .subscribe(
                  success => {
                     this.isTokenValid = false;
                  }, error => {
                      if (error.status === Constants.BUSINESS_ERROR_CODE) {
                          this.isTokenValid = true;
                      }
                  }
              );
      }
      else {
          this.notifService.error('Please fill the form correctly');
          this.unsubscribeAlertForm.markAllAsTouched();
      }
  }

}
